
import { ActionInterface, ACTIONS_BASE, MOTIVOS_BAJA_BASE } from './actions.constants';
import { Validators } from "@angular/forms"
import { FormField, ColumnNames } from './form.constants';
import { CaracterService } from '../core/caracter.service';
import { NivelService } from '../core/nivel.service';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from '../utils/paginate.utils';

export const TITULOS_COLUMN_NAMES: ColumnNames[] = [
  { name: "codigo", label: "Cod" , allowFilter:true},
  { name: "descripcion", label: "Descripción" , allowFilter:true},
  { name: "caracter.descripcion", label: "Caracter" },
  { name: "nivel.descripcion", label: "Nivel" },
  { name: "observacion", label: "Observación" , allowFilter:true},
  { name: "fecha_alta", label: "Fecha Alta" , pipe:'date', allowFilter:true},
  { name: "deleted_at", label: "Fecha Baja" , pipe:'date', allowFilter:true},

]
export const TITULOS_COLUMN_NAMES_ASIGNAR: ColumnNames[] = [
  { name: "codigo", label: "Cod" , allowFilter:true},
  { name: "descripcion", label: "Descripción" , allowFilter:true},
  { name: "caracter.descripcion", label: "Caracter" },
  { name: "observacion", label: "Observación" , allowFilter:true}
]
export const TITULOS_COLUMN_NAMES_DETAILS: ColumnNames[] = [
  { name: "codigo", label: "Cod" , allowFilter:true},
  { name: "descripcion", label: "Descripción" , allowFilter:true},
  { name: "fecha_alta", label: "Fecha Alta" , pipe:'date', allowFilter:true},
  { name: "deleted_at", label: "Fecha Baja" , pipe:'date', allowFilter:true},
  { name: "nivel.descripcion", label: "Nivel" },
  { name: "caracter.descripcion", label: "Carácter" },
  { name: "observacion", label: "Observación" , allowFilter:true}
]

export const TITULOS_FIELDS_CONFIG : { [field:string] : FormField } = {
  descripcion: {
      label: 'Descripción',
      type: 'text',
      position: 1,
    },
    caracter: {
      label: 'Carácter',
      type: 'text',
      position: 2,
    },
    observacion: {
      label: 'Observación',
      type: 'text',
      position: 2,
    },
}
export const TITULOS_FIELDS_FORM : {[name: string]:FormField} = {
    descripcion: {
      label: 'Descripción',
      type: 'text',
      position: 1,
      validations: [Validators.required]
    },
    caracter_id: {
      label: 'Carácter',
      type: 'select',
      position: 3,
      serviceForSelect: CaracterService,
      validations: [Validators.required]
    },
    nivel_id: {
      label: 'Nivel',
      type: 'select',
      position: 2,
      serviceForSelect: NivelService,
      validations: [Validators.required]
    },
    // fecha_alta: {
    //   label: 'Fecha Inicio',
    //   type: 'date',
    //   position: 4,
    //   // validations: [Validators.required]
    // },
    observacion: {
      label: 'Observación',
      type: 'textarea',
      position: 5,
      validations: [Validators.minLength(2)]
    },
  }
export const TITULOS_ACTIONS : {[name:string]:ActionInterface}=
  {
    ...ACTIONS_BASE,
  "Asignar competencia" : {
    icon:"assignment",
    traslation:"Asignar Competencia",
    url:'competencias',
    type:'link'
  }
}
export const TITULOS_ACTIONS_CONSULTA : {[name:string]:ActionInterface}=
  {
  "viewInModal" : {
    icon:"assignment",
    traslation:"Ver Competencias",
    url:'competencias',
    type:'modal',
    showActionsButtons: false,
  },
  // "downloadPDF" : {
  //   icon:"picture_as_pdf",
  //   traslation:"Descargar PDF",
  //   type:'customFunction'
  // }
}
export const TITULOS_MOTIVOS_BAJA = [
  ...MOTIVOS_BAJA_BASE,
];
export const TITULOS_PAGINATE_OPTIONS:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
}


